// tslint:disable:no-any (autogenerated)
import dispatcher from './dispatcher';

class BaseAction implements IBaseAction {
    private requests: Promise<any>[] = [];

    public dispatchEventName: string = '';
    public dispatchResetEventName: string = '';

    public async wait(time?: number): Promise<{}> {
        // tslint:disable-next-line:no-inferred-empty-object-type (autogenerated)
        return new Promise(resolve => {
            setTimeout(resolve, time || 300);
        });
    }

    public static dispatch(eventName: string, data: any): void {
        const eventNameToDispatch = eventName;
        if (!eventNameToDispatch) {
            console.error('Не задано имя события!');
        }

        dispatcher.dispatch(eventNameToDispatch, data);
    }

    public dispatch(data: any, eventName?: string): void {
        const eventNameToDispatch = eventName ? eventName : this.dispatchEventName;
        BaseAction.dispatch(eventNameToDispatch, data);
    }

    public recycle(): void {
        if (!this.dispatchResetEventName) {
            console.error('Не задано имя события!');
            return;
        }
        dispatcher.dispatch(this.dispatchResetEventName);
    }

    public setProcessing(processing: boolean): void {
        this.dispatch({ processing });
    }

    public setServerError(serverError: string): void {
        this.dispatch({ serverError });
    }

    public async startProcessing<T>(request: Promise<T>): Promise<T> {
        this.requests.push(request);
        this.setProcessing(true);
        const removeRequest = res => {
            const index = this.requests.indexOf(request);
            if (index >= 0) {
                this.requests.splice(index, 1);
                this.setProcessing(this.requests.length > 0);
            }
            return res;
        };
        request.then(removeRequest).catch(removeRequest);

        return request;
    }
}

// tslint:disable-next-line:no-default-export (autogenerated)
export default BaseAction;
